<template>
    <el-dialog
        :visible.sync="dialogShow"
        append-to-body
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="800px"
        custom-class="material-detail-dialog"
        @close="handleClose"
    >
        <template #title>
            <material-detail-header :detail-data="detailData"></material-detail-header>
        </template>
        <material-detail
            v-if="Object.keys(detailData).length > 0"
            :detail-data="detailData"
            :show-header="false"
            @getDetail="getMaterialDetail"
        >
        </material-detail>
    </el-dialog>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import MaterialDetailHeader from './material-detail-header';
import MaterialDetail from './material-detail';

export default {
    name: 'MaterialDetailDialog',
    components: {
        MaterialDetailHeader,
        MaterialDetail
    },
    data() {
        return {
            dialogShow: false,
            materialGuid: '',
            detailData: {}
        };
    },
    computed: {
        ...mapGetters(['userInfo', 'materialDetailDialog'])
    },
    mounted() {
        this.dialogShow = this.materialDetailDialog.show;
        this.materialGuid = this.materialDetailDialog.materialguid;
        if (this.materialGuid) {
            this.getMaterialDetail();
        }
    },
    methods: {
        ...mapActions(['openMembershipDialog', 'getUserInfo', 'closeMaterialDetailDialog']),
        handleClose() {
            this.getUserInfo();
            this.closeMaterialDetailDialog();
        },
        // 素材详情
        getMaterialDetail(materialGuid) {
            if (materialGuid) {
                this.materialGuid = materialGuid;
            }
            // TODO: 加载素材详情
            this.$Api
                .getMaterialDetail({
                    materialguid: this.materialGuid
                })
                .then((data) => {
                    this.detailData = data;
                    this.$Api.insertclickactionhistroy({
                        userguid: this.userInfo.userguid,
                        materialguid: this.materialGuid
                    });
                });
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../style/common.scss';
@import './style/material-detail-dialog.scss';
</style>
